import { ExternalProviderPlan, ProviderType } from '../api/useExternalProviderPlans';

export const getConfiguredContentHtml = (
  plan: ExternalProviderPlan | null | undefined,
  providerType: ProviderType,
): string | undefined => {
  const contentHtml = plan?.type_configs?.find((c) => c.provider_type === providerType)?.content_html;
  if (!contentHtml || contentHtml === '<p></p>') {
    return undefined;
  }
  return contentHtml;
};
